import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { RootState } from 'client/store/configureStore';

interface DesignSyncStatusState {
  statuses: Record<string, boolean>;
}

const initialState: DesignSyncStatusState = {
  statuses: {},
};

const designSyncStatusSlice = createSlice({
  name: 'designSyncStatus',
  initialState,
  reducers: {
    syncStatusReceived: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.statuses = action.payload;
    },
    syncStarted: (state, action: PayloadAction<{ designid: string, isSyncing: boolean }>) => {
      const { designid, isSyncing } = action.payload;
      state.statuses[designid] = isSyncing;
    },
    syncStartedBatch: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.statuses = {
        ...state.statuses,
        ...action.payload,
      }
    }
  },
});

export const { syncStatusReceived, syncStarted, syncStartedBatch } = designSyncStatusSlice.actions;

export default designSyncStatusSlice.reducer;

export const selectDesignSyncStatus = (designid: string) => (state: RootState) =>
  state.entities.designSyncStatus.statuses[designid] ?? false;

export const fetchDesignSyncStatus = (designids: string[]) => {
  return apiCallBegan({
    url: `/design/sync-status`,
    method: 'POST',
    data: { designids },
    onSuccess: syncStatusReceived.type
  });
}

export const setDesignSyncing = (designid: string) =>
  syncStarted({ designid, isSyncing: true });
